import React from "react";
/* data import */
import { chefBioData, chefImages } from "../data/chefBioData";

const ChefThumbsWrapper = ({ handleChefInfoClick }) => {
  return (
    <div className="chefs-thumbs-wrapper">
      <div>
        <h1 className="mb-2 mb-lg-3 chefs-head text-center">
          Chefs Who Inspire Us
        </h1>
        <div className="chefs-thumbs">
          {chefBioData.length > 0 &&
            chefBioData.map((val, i) => (
              <div
                key={i}
                className="chefs-thumb"
                onClick={() => handleChefInfoClick(val.chefBioSlug)}
              >
                <div className="chefs-thumb-img">
                  <img src={chefImages[val.imageLink]} alt={val.chefName} />
                </div>
                <div className="chefs-thumb-name">{val.chefName}</div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ChefThumbsWrapper;
